import React, { Component, Fragment } from "react";

class AgencyPricingSelect extends Component {
  render() {
    const {
      accountPackage,
      changePaymentInterval,
      paymentInterval,
      updatePaymentInterval
    } = this.props;
    return (
      <Fragment>
        <div className="aboss__signup-agency-select-options">
          <h1>Select your billing cycle:</h1>
          <div
            className={`aboss__signup-agency-select-option ${
              paymentInterval === "month" ? "selected" : ""
            }`}
            onClick={() => changePaymentInterval("month")}
          >
            <input
              type="radio"
              name="paymentInterval"
              value="month"
              onChange={updatePaymentInterval}
              checked={paymentInterval === "month"}
            />
            <div className="aboss__signup-agency-select-option-info">
              <h1>Monthly</h1>
              {accountPackage === "small" && <h2>€ 145,- per month</h2>}
              {accountPackage === "medium" && <h2>€ 320,- per month</h2>}
              {accountPackage === "large" && <h2>€ 580,- per month</h2>}
            </div>
          </div>
          <div
            className={`aboss__signup-agency-select-option ${
              paymentInterval === "year" ? "selected" : ""
            }`}
            onClick={() => changePaymentInterval("year")}
          >
            <input
              type="radio"
              name="paymentInterval"
              value="year"
              onChange={updatePaymentInterval}
              checked={paymentInterval === "year"}
            />
            <div className="aboss__signup-agency-select-option-info">
              <h1>Annually</h1>
              {accountPackage === "small" && <h2>€ 131,- per month, paid annually</h2>}
              {accountPackage === "medium" && <h2>€ 288,- per month, paid annually</h2>}
              {accountPackage === "large" && <h2>€ 522,- per month, paid annually</h2>}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AgencyPricingSelect;



// WEBPACK FOOTER //
// src/views/sign-up-agency/pricing-select.js